exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile_icons[data-v-08419732]{padding-right:25px}.profile_icons[data-v-08419732]:hover{color:#fff!important}", ""]);

// exports
